import { format, isSameDay } from "date-fns";
import _ from "lodash";
import { AURA_OUTCOME } from "../config/const/enums.js";

export function coverWithinRange(amount, minAmount, maxAmount) {
	const checkValues = !amount || !minAmount || !maxAmount;
	if (checkValues) return false;

	return (
		Number(amount) >= Number(minAmount) && Number(amount) <= Number(maxAmount)
	);
}

export const areAllValuesEmptyNullOrUndefined = (obj) => {
	return _.every(
		obj,
		(value) => _.isNull(value) || _.isUndefined(value) || value === ""
	);
};

export function removeEmptyAndUndefinedValues(obj) {
	const cleanedObject = {};

	for (const key in obj) {
		if (obj.hasOwnProperty(key)) {
			const value = obj[key];
			if (value !== null && value !== undefined && value !== "") {
				cleanedObject[key] = value;
			}
		}
	}

	return cleanedObject;
}

export function objectToQueryParam(obj) {
	const queryParams = [];
	for (const key in obj) {
		if (
			obj.hasOwnProperty(key) &&
			obj[key] !== undefined &&
			obj[key] !== null &&
			obj[key] !== ""
		) {
			queryParams.push(
				`${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`
			);
		}
	}
	return queryParams.join("&");
}

export const hasExpiredItem = (data) => {
	return _.filter(data, { expired: true });
};

export const hasNotExpiredItem = (data) => {
	return _.filter(data, { expired: false });
};

export const getQuoteStatusMapping = (quoteState) => {
	return quoteState?.contractStage + quoteState?.processStatus;
};

export const getDateDDMMYYYFormat = (inputDate) => {
	try {
		if (inputDate) {
			return format(new Date(inputDate), "dd/MM/yyyy");
		}
	} catch (error) {
		return "";
	}
};

export const matchPPStrings = (inputString) => {
	const regex = /PP[0-9A-Za-z]/g;
	return regex.test(inputString);
};

export const matchAuraStatus = (auraStatus) => {
	const isPostponed = matchPPStrings(auraStatus);
	if (isPostponed) {
		return AURA_OUTCOME.PP;
	}

	switch (auraStatus) {
		case "ACC":
			return AURA_OUTCOME.ACC;
		case "DCL":
			return AURA_OUTCOME.DCL;
		case "RUW":
			return AURA_OUTCOME.RUW;
		default:
			return AURA_OUTCOME.NONE;
	}
};

export const matchReferralCode = (covers) => {
	const { life, unableToWork, criticalIllness } = { ...covers };

	if (life?.auraStatus === "RUW") return "Life cover";
	if (criticalIllness?.auraStatus === "RUW") return "Critical Illness cover";
	if (unableToWork?.auraStatus === "RUW")
		return "Permanently unable to work Cover";
};

export const matchOccupationList = (occupationNumber) => {
	switch (occupationNumber) {
		case "01":
			return "01-A";
		case "04":
			return "04-B";
		case "07":
			return "07-C";
		case "08":
			return "08-D";
		case "11":
			return "11-U";
		default:
			return occupationNumber;
	}
};

export const matchInsuranceList = (insuranceItems) => {
	const insuredItems = insuranceItems.split(",");

	return insuredItems;
};

export const getExpiredPolicyStatus = (transactionUid, searchQuoteDetails) => {
	const policyDetails = _.find(searchQuoteDetails, {
		transactionUid: transactionUid,
	});
	if (policyDetails) {
		return policyDetails.expired;
	}
	return null;
};

export const isAdditionalPolicyPresent = (inputData) => {
	return (
		_.isDate(inputData?.additionalPolicyHolderDOB) &&
		!_.isEmpty(inputData?.additionalPolicyHolderFirstName) &&
		!_.isEmpty(inputData?.additionalPolicyHolderSurname) &&
		!_.isEmpty(inputData?.additionalPolicyHolderTitle)
	);
};

export const isAdditionalPolicyPresentRetrieve = (inputData) => {
	return (
		!_.isEmpty(inputData?.dateOfBirth) &&
		!_.isEmpty(inputData?.firstName) &&
		!_.isEmpty(inputData?.surname) &&
		!_.isEmpty(inputData?.title)
	);
};

export const checkIfItContainsAnyValue = (
	additionalPolicyTitle,
	additionalPolicyFirstName,
	additionalPolicySurname,
	additionalPolicyDOB
) => {
	if (
		!_.isEmpty(additionalPolicyTitle) ||
		!_.isEmpty(additionalPolicyFirstName) ||
		!_.isEmpty(additionalPolicySurname) ||
		_.isDate(additionalPolicyDOB)
	) {
		return true;
	} else {
		return false;
	}
};

export const isAdditionalPolicySameAsPrimary = (formData) => {
	if (!formData?.additionalPolicyHolderFirstName) return;

	return (
		formData?.personOne_firstName?.toLowerCase() ===
			formData?.additionalPolicyHolderFirstName?.toLowerCase() &&
		formData?.personOne_surname?.toLowerCase() ===
			formData?.additionalPolicyHolderSurname?.toLowerCase() &&
		formData?.personOne_title?.toLowerCase() ===
			formData?.additionalPolicyHolderTitle?.toLowerCase() &&
		isSameDay(formData?.personOne_dob, formData?.additionalPolicyHolderDOB)
	);
};
